/** Shared keyboard focus treatment for interactive ui components. */
export const focusRing =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-(--k-focus-offset-color)';
